import { Component, OnInit } from '@angular/core';
import { Http } from '@angular/http';
import { FormGroup, NgForm } from '@angular/forms';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {
  name = '';
  phone = '';
  email = '';
  businessName = '';
  message = '';
  robot: boolean;
  endpoint: string;
  showMessage = false;
  submissionName: string;
  showSubmitButton = false;
  //contactForm: ngForm;

  http: Http;

  constructor(http: Http) { this.http = http; }

  ngOnInit() {
    this.endpoint = 'https://aerowestatl.com/contact.php';
  }
  processForm(contactForm: NgForm) {
    // const allInfo = `My name is ${this.name}. My email is ${this.email}. My phone is ${this.phone}. My Business Name is ${this.businessName}. My message is ${this.message}. Robot is ${this.robot}.`;
    // alert(allInfo);
    this.sendEmail(contactForm);
  }

  sendEmail(contactForm: NgForm) {
    const postVars = {
      email : this.email,
      name : this.name,
      phone : this.phone,
      businessName : this.businessName,
      message : this.message
    };

    if (contactForm.valid) {
      this.submissionName = this.name;

      this.http.post(this.endpoint, postVars)
      .subscribe(
          response => console.log(response),
          response => console.log(response)
      );

      this.showMessage = true;
      contactForm.reset();
    }
  }
}
